export default __webpack_public_path__ + "static/black-black-bananatex-933632970dfc5a37e84b83611efa05d2.png";